import { takeFrom2oawu6chjqyp9 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function url(_this__u8e3s4, url) {
  takeFrom(_this__u8e3s4.p5h_1, url);
}
//region block: exports
export {
  url as url1qder21xodqzl,
};
//endregion

//# sourceMappingURL=buildersWithUrl.mjs.map
